import React, { useEffect, useRef, useCallback, useMemo } from 'react';
import TreeView from 'devextreme-react/tree-view';
import { navigation, navigationManager, navigationOfficeManager, navigationOperator } from '../../app-navigation';
import { useNavigation } from '../../contexts/navigation';
import { useScreenSize } from '../../utils/media-query';
import './SideNavigationMenu.scss';


import * as events from 'devextreme/events';


import { Logout, IsRole_Admin, IsRole_Manager,IsRole_OfficeManager, IsRole_Operator,IsRole_SecurityManager,IsRole_OfficeAuditor } from '../../globals';
import { useAuth } from  '../../contexts/auth'; 


export default function SideNavigationMenu(props) {

  var isOperator = false;
  var isManager = false;
  var isOfficeManager = false;
  var isAdmin = false;
  var isSecurityManager = false;
  var isOfficeAuditor = false;

  //autenticazione
  const { user } = useAuth(); 

  if (!user) 
    Logout();
  else
  {
    //console.log('Username NAV:' + user.username);
    //console.log('ID NAV:' + user.userId);
    isAdmin =IsRole_Admin(); 
    isOfficeManager =IsRole_OfficeManager();
    isManager =IsRole_Manager();
    isOperator =IsRole_Operator(); 
    isSecurityManager =IsRole_SecurityManager(); 
    isOfficeAuditor =IsRole_OfficeAuditor();
  } 

  const userRoles = [];
  if (IsRole_Admin()) userRoles.push('admin');
  if (IsRole_Manager()) userRoles.push('manager');
  if (IsRole_OfficeManager()) userRoles.push('officeManager');
  if (IsRole_Operator()) userRoles.push('operator');
  if (IsRole_SecurityManager()) userRoles.push('securityManager');
  if (IsRole_OfficeAuditor()) userRoles.push('officeAuditor');

  const {
    children,
    selectedItemChanged,
    openMenu,
    compactMode,
    onMenuReady
  } = props;

  const { isLarge } = useScreenSize();
  // function normalizePath () {
  //   return navigation.map((item) => (
  //     { ...item, expanded: isLarge, path: item.path && !(/^\//.test(item.path)) ? `/${item.path}` : item.path }
  //   ))
  // }

  function filterMenuByRoles(menuItems, userRoles) {
  return menuItems
    .filter(item => {
      // Se non c'è la proprietà `roles`, mostralo per default
      if (!item.roles) return true;
      return item.roles.some(role => userRoles.includes(role));
    })
    .map(item => {
      const newItem = { ...item };
      if (item.items) {
        newItem.items = filterMenuByRoles(item.items, userRoles);
      }
      return newItem;
    });
}

  // function normalizePath () {
  //   if (isAdmin) {
  //     return navigation.map((item) => (
  //       { ...item, expanded: isLarge, path: item.path && !(/^\//.test(item.path)) ? `/${item.path}` : item.path }
  //     ))
  //   }
  //   else if (isOfficeManager) {
  //     return navigationOfficeManager.map((item) => (
  //       { ...item, expanded: isLarge, path: item.path && !(/^\//.test(item.path)) ? `/${item.path}` : item.path }
  //     ))
  //   }
  //   else if (isManager) {
  //     return navigationManager.map((item) => (
  //       { ...item, expanded: isLarge, path: item.path && !(/^\//.test(item.path)) ? `/${item.path}` : item.path }
  //     ))
  //   }
  //   else if (isOperator) {
  //     return navigationOperator.map((item) => (
  //       { ...item, expanded: isLarge, path: item.path && !(/^\//.test(item.path)) ? `/${item.path}` : item.path }
  //     ))
  //   }
  //   else {
  //     return navigationOperator.map((item) => (
  //       { ...item, expanded: isLarge, path: item.path && !(/^\//.test(item.path)) ? `/${item.path}` : item.path }
  //     ))
  //   }
  // }

  function normalizePath() {
  return filterMenuByRoles(navigation, userRoles).map((item) => ({
    ...item,
    expanded: isLarge,
    path: item.path && !/^\//.test(item.path) ? `/${item.path}` : item.path
  }));
}


  const items = useMemo(
    normalizePath,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const { navigationData: { currentPath } } = useNavigation();

  const treeViewRef = useRef(null);
  const wrapperRef = useRef();
  const getWrapperRef = useCallback((element) => {
    const prevElement = wrapperRef.current;
    if (prevElement) {
      events.off(prevElement, 'dxclick');
    }

    wrapperRef.current = element;
    events.on(element, 'dxclick', (e) => {
      openMenu(e);
    });
  }, [openMenu]);

  useEffect(() => {
    const treeView = treeViewRef.current && treeViewRef.current.instance();
    if (!treeView) {
      return;
    }

    if (currentPath !== undefined) {
      treeView.selectItem(currentPath);
      treeView.expandItem(currentPath);
    }

    //if (compactMode) {
      treeView.collapseAll();
    //}
  }, [currentPath, compactMode]);

  return (
    <div
      className={'dx-swatch-additional side-navigation-menu'}
      ref={getWrapperRef}
    >
      {children}
      <div className={'menu-container'}>
        <TreeView
          ref={treeViewRef}
          items={items}
          keyExpr={'path'}
          selectionMode={'single'}
          focusStateEnabled={false}
          expandEvent={'click'}
          onItemClick={selectedItemChanged}
          onContentReady={onMenuReady}
          width={'100%'}
        />
      </div>
    </div>
  );
}
